import { useRemoveFavoritePeerWithParams, useAddFavoritePeerWithParams } from '../../hooks/api/usePeers';
import useAuth from '../../hooks/utils/useAuth';
import { useHubspotEventMutation } from '../../hooks/api/useEvent';
import { StarButtonBase } from './star-button-base';
import { useEffect, useState } from 'react';

interface FollowPeerStarButtonProps {
  isFavorite: boolean;
  listenerRoleId: number;
  listenerName: string;
  className?: string;
}

export const FollowPeerStarButton: React.FC<FollowPeerStarButtonProps> = ({
  isFavorite,
  listenerRoleId,
  listenerName,
  className = '',
}) => {
  const { user } = useAuth();
  const hubspotMutation = useHubspotEventMutation();
  const removeFavoritePeer = useRemoveFavoritePeerWithParams();
  const addFavoritePeer = useAddFavoritePeerWithParams();
  const isPending = addFavoritePeer.isLoading || removeFavoritePeer.isLoading;
  const [optimisticIsFavorite, setOptimisticIsFavorite] = useState(isFavorite);

  useEffect(() => {
    setOptimisticIsFavorite(isFavorite);
  }, [isFavorite]);

  const handleToggle = () => {
    setOptimisticIsFavorite(!optimisticIsFavorite);
    if (isFavorite) {
      removeFavoritePeer.mutate(listenerRoleId);
    } else {
      hubspotMutation.mutate({
        event: 'follow_peer',
        properties: { client: user!.client_name, email_address: user!.email_address, peer_name: listenerName },
      });
      addFavoritePeer.mutate(listenerRoleId);
    }
  };

  return (
    <StarButtonBase
      isFavorite={optimisticIsFavorite}
      onToggle={handleToggle}
      isLoading={isPending}
      className={className}
    />
  );
};
